module.exports = __webpack_public_path__ + "static/media/40.ff414cd0.png";